























































import Vue from 'vue';
import Component from 'vue-class-component';
import { email, required } from 'vuelidate/lib/validators';
import { mapGetters, mapState } from 'vuex';
import FormInput from '@/components/ui/FormInput.vue';
import Customer from '@/models/Customer';

interface ForgetRequest {
	location: string;
	email: string;
}

const Setup = Vue.extend({
	name: 'ForgetForm',
	components: {
		FormInput,
	},
	props: {
		classes: [Array, Object, String],
		idPrefix: String,
		title: String,
		registerText: {
			type: String,
			default: 'Sign Up',
		},
		type: {
			type: String,
			default: 'login-only',
		},
		value: {
			type: Object,
		},
	},
	computed: {
		...mapState(['isLoading', 'paths']),
		...mapGetters('location', ['location']),
	},
	validations: {
		email: { email, required },
	},
});

@Component
export default class ForgetForm extends Setup {
	// Props
	public classes!: string;
	public idPrefix!: string;
	public title!: string;
	public type!: string;
	public registerText!: string;
	public value!: { email: string; location: string };

	// Data
	public email: string = '';
	public localErrors: any = {};
	public message: string = '';

	// State
	public isLoading!: boolean;
	public paths!: any;

	// Getters
	public location!: Locations.Location;

	public get model(): ForgetRequest {
		return {
			email: this.email,
			location: this.location.codeID || '',
		};
	}

	public async submit() {
		this.$v.$touch();
		this.localErrors = {};

		if (this.$v.$invalid) {
			return;
		}

		try {
			const response = await Customer.lostPassword(this.model.email, this.model.location);
			this.$emit('requested-reset', response);
			this.message = 'If an account exists, an email will be sent with instructions to reset your password.';
		} catch ({ response }) {
			if (Array.isArray(response.data.errors)) {
				response.data.errors.forEach((error: any) => {
					if (error.name) {
						this.$set(this.localErrors, error.name, error.text);
					} else {
						this.$set(this.localErrors, 'page', error.text);
					}
				});
			}
		}
	}

	public toggleSignIn() {
		this.$emit('sign-in');
	}
}
